import { Badge } from '@/components/ui/badge';

import { accountLabel } from './group-templates';

import type { TemplateGroupAccount } from './group-templates';

export const statusBadgeVariant = (
  status: string,
): 'default' | 'secondary' | 'destructive' | 'outline' => {
  switch (status) {
    case 'APPROVED':
      return 'default';
    case 'PENDING':
      return 'secondary';
    case 'REJECTED':
      return 'destructive';
    default:
      return 'outline';
  }
};

interface TemplateAccountListProps {
  accounts: TemplateGroupAccount[];
}

/** One line per WhatsApp Business Account showing where a template group stands. */
export const TemplateAccountList = ({ accounts }: TemplateAccountListProps) => (
  <ul className="divide-border divide-y">
    {accounts.map((account) => (
      <li
        key={account.waba_id}
        className="flex flex-wrap items-start justify-between gap-x-6 gap-y-1 py-2 text-sm"
      >
        <div className="min-w-0">
          <p className="font-medium">{accountLabel(account)}</p>
          <p className="text-muted-foreground font-mono text-xs">
            WABA {account.waba_id}
            {account.row?.meta_template_id && ` · Meta ID ${account.row.meta_template_id}`}
          </p>
          {account.row?.rejected_reason && (
            <p className="text-destructive mt-1 text-xs">{account.row.rejected_reason}</p>
          )}
        </div>
        {account.row ? (
          <div className="flex items-center gap-3">
            <Badge variant={statusBadgeVariant(account.row.status)}>{account.row.status}</Badge>
            <span className="text-muted-foreground text-xs">
              {new Date(account.row.updated_at).toLocaleString()}
            </span>
          </div>
        ) : (
          <Badge variant="outline">Not on this account</Badge>
        )}
      </li>
    ))}
  </ul>
);
